import { Box } from "@mui/material";
import { linko } from "@shared/linko";
import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import { KPI_META } from "../kpiMeta";
import {
  buildStatisticsQueryFilters,
  type KpiAvgTimeDistributionBucket,
  type StatisticsFilters,
} from "../types";
import { KpiDialogScaffold } from "./KpiDialogScaffold";
import { KpiTimeDistributionChart } from "./KpiTimeDistributionChart";

interface KpiAvgTimeDistributionDialogProps {
  open: boolean;
  onClose: () => void;
  organizationId: string | undefined;
  filters: StatisticsFilters;
}

export const KpiAvgTimeDistributionDialog: FC<KpiAvgTimeDistributionDialogProps> = ({
  open,
  onClose,
  organizationId,
  filters,
}) => {
  const meta = KPI_META.avgTimeToFull;
  const { data, isLoading, error } = useQuery({
    queryKey: ["statistics-kpi-avg-time-distribution", organizationId, filters],
    queryFn: async () => {
      const { data: payload } =
        await linko.statistics.queries.getKpiAvgTimeDistribution(
          buildStatisticsQueryFilters(organizationId!, filters),
        );
      return payload as KpiAvgTimeDistributionBucket[];
    },
    enabled: open && !!organizationId,
    staleTime: 60_000,
  });

  return (
    <KpiDialogScaffold
      open={open}
      onClose={onClose}
      title={meta.dialogTitle}
      explanation={meta.explanation}
      isLoading={isLoading}
      error={error}
      footerNote="ציר ה-X מציג את טווחי זמן המאצ׳ מהיר לאיטי, וציר ה-Y מציג את מספר המשימות בכל טווח."
    >
      {data && (
        <Box sx={{ width: "100%" }}>
          <KpiTimeDistributionChart
            title="התפלגות זמן מאצ׳ (עד מתנדב ראשון)"
            data={data}
          />
        </Box>
      )}
    </KpiDialogScaffold>
  );
};
